import { render, staticRenderFns } from "./CartNav.vue?vue&type=template&id=0b1c220e&scoped=true"
import script from "./CartNav.vue?vue&type=script&lang=js"
export * from "./CartNav.vue?vue&type=script&lang=js"
import style0 from "./CartNav.vue?vue&type=style&index=0&id=0b1c220e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b1c220e",
  null
  
)

export default component.exports